/* Copyright (c) 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Box, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { ChartLegend } from "./ChartLegend";
import { StatusChart } from "./StatusChart";
import { StatusChartItem } from "./types";

type Props = {
  title: string;
  items: StatusChartItem[];
  loading: boolean;
  hasChart?: boolean;
};

export function SummaryCard({ title, items, loading, hasChart = true }: Props) {
  return (
    <Box
      padding={theme.spacing.spacing04}
      css={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Text weight="medium">{title}</Text>
      <FlexContainer
        gap={theme.spacing.spacing07}
        alignItems="center"
        css={{ flex: 1, minHeight: 0 }}
      >
        <When condition={hasChart}>
          <div css={{ maxWidth: "200px" }}>
            <StatusChart
              items={items}
              chartLabel="resources"
              loading={loading}
            />
          </div>
        </When>
        <ChartLegend items={items} itemsPerColumn={5} loading={loading} />
      </FlexContainer>
    </Box>
  );
}
